import { type ParsedReceipt } from './ParsedReceiptSummary';

const ParsedReceiptSummary: React.FC<{ result: ParsedReceipt }> = ({ result }) => {
  return (
    <div className="flex flex-col justify-between flex-grow">
      <p>
        {result.parsedItems.globalIdentifiers.map((identifier) => (
          <>
            <span className="font-bold">{identifier.key}</span> {identifier.value}
          </>
        ))}
      </p>
      <p>Line Items</p>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          {result.parsedItems.lineItems.map((lineItem, index) => {
            return (
              <tr key={index}>
                <td>{lineItem.name}</td>
                <td>{lineItem.quantity}</td>
                <td>{lineItem.unitPrice}</td>
                <td>{lineItem.totalPrice}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ParsedReceiptSummary;
